import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { applicationRouteNames } from '../application-route-names';
import { ProfileService } from './profile.service';

/**
 * Redirige vers le profil si celui-ci est incomplet.
 * Équivalent du resolver `needProfile` de l'ancien OSER (pas d'authentification).
 */
export const profileCompleteGuard: CanActivateFn = () => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  return profileService.isComplete() ? true : router.createUrlTree([applicationRouteNames.profile]);
};
